(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activities-navigation"] && !Shopify.designMode) return;
  try {
    
    (function () {
        const activitiesRoot = document.querySelector('[data-activities]');
        if (!activitiesRoot) return;

            const items = activitiesRoot.querySelectorAll('[data-activity-item]');
            const images = activitiesRoot.querySelectorAll('[data-activity-image]');

            function activate(index) {
            items.forEach(item => item.classList.remove('is-active'));
            images.forEach(img => img.classList.remove('is-active'));

            items[index]?.classList.add('is-active');
            images[index]?.classList.add('is-active');
        }

        items.forEach(item => {
        item.addEventListener('mouseenter', function () {
            const index = Number(this.dataset.index);
            activate(index);
        });
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });



  document.addEventListener('click', function (event) {
    const searchBar = document.getElementById('search-bar');
    const searchToggles = document.querySelectorAll('.js-show-search, .js-show-search-left');
    const header = document.querySelector('store-header');

    if (!searchBar) return;

    const clickedInsideSearch = searchBar.contains(event.target);
    const clickedToggle = Array.from(searchToggles).some((toggle) =>
      toggle.contains(event.target)
    );

    const clickedOverlay = event.target.closest('.js-search-overlay');

    const clickedCarousel = event.target.closest('carousel-slider');
    const clickedSliderNav = event.target.closest('.slider-nav__btn');

    if (
      !clickedInsideSearch &&
      !clickedToggle &&
      !clickedOverlay &&
      !clickedCarousel &&
      !clickedSliderNav
    ) {
      const predictiveSearch = document.querySelector('predictive-search');

      if (predictiveSearch?.hasAttribute('open')) {
        predictiveSearch.close(event);
      }

      header?.classList.remove('search-is-visible', 'search-is-visible-hold');
      header?.classList.add('search-is-collapsed');
      document.body.classList.remove('overflow-hidden', 'fixed');
    }
  });

  document.addEventListener('click', function (event) {
    const closeBtn = event.target.closest('.search__close');
    if (!closeBtn) return;

    const predictiveSearch = document.querySelector('predictive-search');
    if (predictiveSearch && predictiveSearch.close) {
      // Pass the event so close() can detect it came from the close button
      predictiveSearch.close(event);
    }

    document.activeElement.blur();

    setTimeout(() => {
      document.body.classList.remove('overflow-hidden', 'fixed', 'overlay-predictive-search');
      const header = document.querySelector('store-header');
      if (header) {
        header.classList.remove('search-is-visible', 'search-is-visible-hold');
        header.classList.add('search-is-collapsed');
      }
    }, 50);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('glaze-product-rail')) {
    customElements.define('glaze-product-rail', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const track = this.querySelector('.gpr__track');
        const body = this.querySelector('.gpr__body');
        const disclosure = this.querySelector('details');
        const arrows = [...this.querySelectorAll('[data-step]')];
        if (!track || !body) return;
        const update = () => {
          const items = [...track.children];
          const bounds = track.getBoundingClientRect();
          const rtl = getComputedStyle(track).direction === 'rtl';
          const first = items[0]?.getBoundingClientRect();
          const last = items.at(-1)?.getBoundingClientRect();
          const overflow = track.scrollWidth > track.clientWidth + 2;
          arrows.forEach(button => {
            button.hidden = !overflow;
            const previous = Number(button.dataset.step) < 0;
            button.disabled = !first || !last || (previous
              ? (rtl ? first.right <= bounds.right + 2 : first.left >= bounds.left - 2)
              : (rtl ? last.left >= bounds.left - 2 : last.right <= bounds.right + 2));
          });
        };
        arrows.forEach(button => button.addEventListener('click', () => {
          const rtl = getComputedStyle(track).direction === 'rtl';
          track.scrollBy({ left: Number(button.dataset.step) * track.clientWidth * .8 * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal }));
        disclosure.addEventListener('toggle', update, { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        this.observer?.disconnect();
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
        this.prepareEntry(signal);
      }
      prepareEntry(signal) {
        if (this.dataset.entry !== 'true' || window.Shopify?.designMode || location.hash) return;
        const navigation = performance.getEntriesByType('navigation')[0];
        if (!navigation || navigation.type !== 'navigate' || window.scrollY > 1) return;
        if (document.querySelector('glaze-product-rail[data-entry="true"]') !== this) return;
        let interacted = false;
        for (const event of ['wheel', 'touchstart', 'pointerdown', 'keydown']) {
          window.addEventListener(event, () => { interacted = true; }, { once: true, passive: true, signal });
        }
        const position = () => {
          if (interacted || signal.aborted || window.scrollY > 1 || !this.isConnected) return;
          let target;
          try { target = document.querySelector(this.dataset.target); } catch { return; }
          if (!target || target.getClientRects().length === 0 || this.contains(target)) return;
          const offset = matchMedia('(max-width: 749px)').matches ? this.dataset.mobileOffset : this.dataset.offset;
          const top = target.getBoundingClientRect().top + window.scrollY - Number(offset || 0);
          if (top > 0) window.scrollTo({ top, behavior: 'instant' });
        };
        if (document.readyState === 'complete') requestAnimationFrame(position);
        else window.addEventListener('load', () => requestAnimationFrame(position), { once: true, signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
